<div *ngIf="share" class="share-badge" [class]="'share-badge--' + displayStatus">
  <div class="share-badge__status">
    <mat-icon class="share-badge__icon">
      {{ displayStatus === 'active' ? 'check_circle' : displayStatus === 'expiring_soon' ? 'schedule' : displayStatus === 'uploaded_to_pacs' ? 'cloud_done' : 'cancel' }}
    </mat-icon>
    <span class="share-badge__label">
      {{ displayStatus === 'active' ? 'Active' : displayStatus === 'expiring_soon' ? 'Expiring soon' : displayStatus === 'uploaded_to_pacs' ? 'Uploaded to PACS' : 'Expired' }}
    </span>
  </div>
  <div class="share-badge__relative" *ngIf="relativeLabel">{{ relativeLabel }}</div>
  <div class="share-badge__exact">{{ exactLabel }}</div>
</div>
